import { CommonModule } from '@angular/common';
import { Component, HostBinding, Inject, signal } from '@angular/core';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DialogButton, DialogData } from './dialog-data.interface';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconButton,
    MatIconModule,
  ],
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
  public type = signal<
    'error' | 'confirm' | 'info' | 'loading' | 'success' | 'warning'
  >('error');
  public title = signal<SafeHtml>('');
  public content = signal<SafeHtml>('');
  public buttons = signal<DialogButton[]>([]);
  public textAlign = signal<'left' | 'center'>('center');

  public constructor(
    public _dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogData,
    private _sanitizer: DomSanitizer,
  ) {
    this.type.set(data.type ?? 'error');
    this.title.set(this._sanitizer.bypassSecurityTrustHtml(data.title));
    this.content.set(
      data.content ? this._sanitizer.bypassSecurityTrustHtml(data.content) : '',
    );
    this.buttons.set(data.buttons ?? []);
    this.textAlign.set(data.textAlign ?? 'center');
  }

  public close(): void {
    this._dialogRef.close();
  }

  public clickButton(button: DialogButton): void {
    if ('action' in button) {
      button.action();
    }
    if ('result' in button) {
      this._dialogRef.close(button.result);
    }
  }

  @HostBinding('class')
  public get typeClass(): string {
    return this.type();
  }
}
